@import 'styles/mixins';
@import 'styles/variables';

.container {
  width: 0;
  @include focus-mode-transition;
  flex-shrink: 0;
  flex-grow: 0;
  @include rightRailTransition(width);
  overflow: hidden;
  max-height: 100vh;
  z-index: 301;

  &.locked {
    width: var(--right-rail-content-width);
  }

  &:before {
    @include focus-mode-transition;
    opacity: 1;
    content: '';
    position: absolute;
    width: var(--right-rail-content-width);
    background-color: var(--editor-top);
  }
}

[data-focus-mode='on'] {
  .container {
    &:before {
      opacity: 0;
    }
  }
}
